import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import './App.css';
import Particles from 'react-particles-js';
import Project from './components/Project';
import Contact from './components/Contact';
import About from './components/About';
import axios from 'axios';
function App() {
  const getData = async () => {
    const res = await axios.get('https://ipinfo.io/json?token=88a6ad297544e8');
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <React.Fragment>
      <Particles
        className='particles-canvas'
        params={{
          particles: {
            number: { value: 70, density: { enable: true, value_area: 900 } },
            shape: { type: 'circle', stroke: { width: 6, color: '#fff' } },
          },
        }}
      />
      <Header />
      <div id='Project' style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: '60px' }}>
          My <span style={{ color: '#03aad7' }}>Projects</span>
        </h1>
      </div>
      <div className='row'>
        <Project
          projectName='Ecommerce'
          projectDescription='Web application to sell and to buy products.It is responsive to use on different type of devices(Frontend - React Js)'
          imageSource='/project-images/Ecommerce/ecommerce.png'
          gitSource='https://github.com/m1172/online-store'
          liveDemo='http://bazar.zapto.org/'
        />

        <Project
          projectName='Clothes'
          projectDescription='Clothes Store Web Application that can be used to organize local online market for new clothes and also connected with fake backend'
          imageSource='/project-images/Clothes/clothes.png'
          gitSource='https://github.com/m1172/clothes'
          liveDemo='https://clothes-stores-pl.netlify.app'
        />

        <Project
          projectName='Online Store'
          projectDescription='Online Mobile Store web Application that can be used to organize local online market for used phones '
          imageSource='/project-images/OnlineStore/OnlineStore.png'
          gitSource='https://github.com/m1172/mobile-store'
          liveDemo='https://mobile-store-uz.netlify.app/'
        />

        <Project
          projectName='Houzing'
          projectDescription='Hozuing Web Application was created by our team. It is only dektop version avialable'
          imageSource='/project-images/Houzing/houzing.png'
          gitSource='https://github.com/m1172/Apartments'
          liveDemo='https://houzing.netlify.app/home'
        />
      </div>
      <About />
      <Contact />
    </React.Fragment>
  );
}

export default App;
